import { Loader2 } from 'lucide-react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/use-auth';

export function ProtectedRoute() {
  const { isAuthenticated, bootstrapped } = useAuth();
  const location = useLocation();

  if (!bootstrapped) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="size-6 animate-spin text-primary" />
      </div>
    );
  }

  if (!isAuthenticated) {
    // The query string is part of the destination, not decoration. `/billing/checkout/success`
    // without its `?subscription=` is a page that cannot tell a customer whether the payment it
    // is confirming went through, and it is reached at the one moment a session is most likely to
    // have lapsed — after a detour through the payment provider. `destinationAfterLogin` already
    // strips `?` before matching the section, so it has always expected to receive one.
    return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
  }

  return <Outlet />;
}
